import {makeAutoObservable} from "mobx";
import {inject, injectable} from "inversify";
import {ViewController} from "data/types/structure";
import {Bindings} from "data/constants/bindings";
import {type IRoundsStore, ITournament} from "data/stores/rounds/rounds.store";
import {type ILocalizationStore} from "data/stores/localization/localization.store";

export interface IStreakTipsController extends ViewController {
	readonly i18n: ILocalizationStore;

	get tournaments(): ITournament[];
}

@injectable()
export class StreakTipsController implements IStreakTipsController {
	get tournaments() {
		return this._roundsStore.selectedRound?.tournaments || [];
	}

	constructor(
		@inject(Bindings.RoundsStore) private _roundsStore: IRoundsStore,
		@inject(Bindings.LocalizationStore) readonly i18n: ILocalizationStore
	) {
		makeAutoObservable(this);
	}
}
